import { SVGProps } from "react";

export default function VerticalDividerIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 27, width = 1, stroke = "#E8E5DE", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <line
        x1="0.5"
        y1="2.18562e-08"
        x2="0.499999"
        y2="26.471"
        stroke={stroke}
      />
    </svg>
  );
}